// import { createStore, applyMiddleware } from "redux";
// import {thunk as reduxThunk} from "redux-thunk";
// import { configureStore } from "@reduxjs/toolkit";
// import rootReduser from "./reducer/index";
// import { composeWithDevTools } from "redux-devtools-extension";

// const middlewares = [reduxThunk];

// const store = configureStore(
//   rootReduser,
//   composeWithDevTools(applyMiddleware(...middlewares))
// );

// export default store;

import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./reducer/index";
import { thunk as reduxThunk } from "redux-thunk"; // Importing named export 'thunk' from redux-thunk

const store = configureStore({
  reducer: rootReducer, // Combine your reducers here
  middleware: (getDefaultMiddleware) => getDefaultMiddleware(), // Add redux-thunk middleware
  devTools: true, // Enable Redux DevTools
});

export default store;
